(function () {
  'use strict';

  function getActiveCurrency() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) {
      return window.Shopify.currency.active;
    }
    return 'EUR';
  }

  var SELECTORS = [
    '.price-item--regular',
    '.price-item--sale',
    '.price-item--last',
    '.product__price .price-item',
    '#price-template--' /* matches any id starting with this */
  ];

  var PRICE_REGEX = /([€$£¥¢₹₽]\s*\d[\d.,]*)/g;
  var GUARDING = false;

  function normalizeOne(el) {
    if (!el) return;
    var raw = el.textContent;
    if (!raw) return;
    var trimmed = raw.trim();
    if (!trimmed) return;

    var currency = getActiveCurrency();
    var updated = trimmed;
    var hasCurrencyChar = /[€$£¥¢₹₽]/.test(trimmed);
    if (!hasCurrencyChar) return;

    if (currency === 'EUR') {
      updated = updated.replace(/(€\s*\d+)\.(\d{1,2})\b/g, '$1,$2');
    }

    var codeRegex = new RegExp('\\b' + currency + '\\b');
    if (!codeRegex.test(updated)) {
      updated = updated.replace(/\s+$/, '') + ' ' + currency;
    }

    if (updated !== trimmed) {
      GUARDING = true;
      var leadingWhitespace = raw.match(/^\s*/)[0];
      var trailingWhitespace = raw.match(/\s*$/)[0];
      el.textContent = leadingWhitespace + updated + trailingWhitespace;
      GUARDING = false;
    }
  }

  function normalizeAll() {
    if (GUARDING) return;
    var nodes = document.querySelectorAll(SELECTORS.slice(0, -1).join(','));
    for (var i = 0; i < nodes.length; i++) {
      normalizeOne(nodes[i]);
    }
  }

  function observePriceContainer(container) {
    if (!container || container.__priceGuardObserved) return;
    container.__priceGuardObserved = true;
    var mo = new MutationObserver(function () {
      if (GUARDING) return;
      normalizeAll();
    });
    mo.observe(container, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  function init() {
    normalizeAll();

    document.querySelectorAll('[id^="price-template--"], .price').forEach(observePriceContainer);

    var bodyObserver = new MutationObserver(function (mutations) {
      if (GUARDING) return;
      var needs = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        if (m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)) {
          needs = true;
          break;
        }
        if (m.type === 'characterData') {
          needs = true;
          break;
        }
      }
      if (needs) {
        normalizeAll();
        document.querySelectorAll('[id^="price-template--"], .price').forEach(observePriceContainer);
      }
    });

    bodyObserver.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
